<template>
    <div>
        <img src="@/assets/img/icon-order-complete.png"/>
        <h1>Tu pedido ha sido realizado. Gracias por confiar en Tallo Verde!</h1>

        <router-link class="button is-primary is-large" :to="{ name: 'Home' }">Volver al Inicio</router-link>
    </div>
</template>

<script>
    export default {
        name: 'checkout-complete',
    }
</script>

<style lang="scss" scoped>
    @import "./../../assets/css/checkout.scss";
</style>